<template>
  <v-combobox
    v-model="text"
    :error-messages="errorMessages"
    :hide-details="false"
    :label="label"
    :items="items"
    clearable
    dense
    outlined
    @input.native="text = $event.srcElement.value"
  />
</template>

<script>
export default {
  props: ["value", "items", "errorMessages", "label"],
  data() {
    return {
      text: "",
    };
  },
  watch: {
    text(val) {
      this.$emit("input", val);
    },
    value: {
      handler(val) {
        this.text = val;
      },
      immediate: true,
    },
  },
};
</script>